import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type LineState } from './types';

interface initialStateNodeEditor {
  isOpenTools: boolean;
  isVisibleTools: boolean;
  isUrlModalOpen: boolean;
  editState: LineState;
}

const initialState: initialStateNodeEditor = {
  isOpenTools: false,
  isVisibleTools: false,
  isUrlModalOpen: false,
  editState: 'normal',
};

const noteEditorSlice = createSlice({
  name: 'noteEditor',
  initialState,
  reducers: {
    toggleOpenTools: (state) => {
      state.isOpenTools = !state.isOpenTools;
    },
    setVisibleTools: (state, actions: PayloadAction<boolean>) => {
      state.isVisibleTools = actions.payload;
    },
    setUrlModalOpen: (state, actions: PayloadAction<boolean>) => {
      state.isUrlModalOpen = actions.payload;
    },
    setEditState: (state, actions: PayloadAction<LineState>) => {
      state.editState = actions.payload;
    },
  },
});

export const noteEditorReducer = noteEditorSlice.reducer;
export const noteEditorActions = noteEditorSlice.actions;
